var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    staticClass: "grey lighten-4",
    staticStyle: {
      "width": "100%",
      "border-radius": "8px!important"
    },
    attrs: {
      "borderless": "",
      "active-class": "white elevation-4",
      "color": "primary"
    }
  }, [_vm._l(_vm.tabs, function (_ref) {
    var text = _ref.text,
        to = _ref.to,
        className = _ref.className;
    return [_c('v-btn', _vm._b({
      key: text,
      staticStyle: {
        "border-radius": "8px!important"
      },
      attrs: {
        "exact": "",
        "width": "calc(100% / 3)"
      },
      on: {
        "!click": function click($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.emit(to);
        }
      }
    }, 'v-btn', {
      to: to,
      class: className
    }, false), [_vm._v(" " + _vm._s(text) + " ")])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }